export const ROUTES = ({ agreementType, createAs }) => [
  {
    label: `${agreementType}-agreement-by-${createAs}`,
    link: '',
  },
  {
    label: 'special-billing-agreements',
    link: 'additional-functionalities/special-billing',
  },
  {
    label: 'additional_functionalities',
    link: 'additional-functionalities',
  },
];
